export const environment = {
  production      : false,
  hmr             : false,
  DB_ID           : '1',
  APP_ID          :  4,
  ACCESS_TOKEN_KEY: "ACCESS_TOKEN_KEY",
  USER_SESSION_KEY: "USER_SESSION_KEY",
  //API_URL         : "http://127.0.0.1:8000/",
  API_URL         : "http://apitest.minka.co/",
  API_CERRAR_SESSION: 60000 
};
